import type { MarkerNoteFormat, MarkerNoteTab, MarkerSheetData, SongMarker } from '../core/types';
import { markerNoteSheet, markerNoteText } from '../core/types';
import { sheetHasContent } from './noteSheet';

export function noteTextHasContent(value: string): boolean {
  return Boolean(value.trim());
}

export function sheetToPlainText(sheet: MarkerSheetData): string {
  return sheet.rows
    .map((row) => row.map((cell) => cell.text).join('\t').replace(/\t+$/u, ''))
    .join('\n')
    .replace(/\n+$/u, '');
}

export function plainTextToSheet(value: string): MarkerSheetData {
  const normalized = value.replace(/\r\n/g, '\n');
  if (!normalized.trim()) return { rows: [] };
  return {
    rows: normalized.split('\n').map((line) => [{ text: line }]),
  };
}

export function noteFormatHasContent(marker: SongMarker, tab: MarkerNoteTab, format: MarkerNoteFormat): boolean {
  return format === 'text' ? noteTextHasContent(markerNoteText(marker, tab)) : sheetHasContent(markerNoteSheet(marker, tab));
}

export function buildSingleFormatNotePatch(
  marker: SongMarker,
  tab: MarkerNoteTab,
  targetFormat: MarkerNoteFormat,
): Pick<SongMarker, 'notes' | 'noteSheets' | 'noteFormats'> {
  const currentText = markerNoteText(marker, tab);
  const currentSheet = markerNoteSheet(marker, tab);

  const nextText =
    targetFormat === 'text'
      ? noteTextHasContent(currentText)
        ? currentText
        : sheetToPlainText(currentSheet)
      : '';
  const nextSheet =
    targetFormat === 'sheet'
      ? sheetHasContent(currentSheet)
        ? currentSheet
        : plainTextToSheet(currentText)
      : { rows: [] };

  return {
    noteFormats: { ...marker.noteFormats, [tab]: targetFormat },
    notes: { ...marker.notes, [tab]: nextText },
    noteSheets: { ...marker.noteSheets, [tab]: nextSheet },
  };
}
